import { AuthModel, EmployeeRolesEnum, ErrorResponse, GlobalStatus, MaterialPreperationStatus, MessageRequest, packingIndentEnum, SoStatusEnum, StockStatus, stockTypeEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { ConsumedQtyRequest, GetAllConsumptionItemsResponseModel, getAllStoreConsumptionsResponse, GetStoreConsumptionDetails, GetStoreConsumptionItemsDto, GetStoreConsumptionResponse, GetStoreConsumptionSosResponseModel, getStoreConsumptionsResponse, indentrequest, IssueDropDownDto, IssuesDropDownResponse, PlaceListPalletDto, SaleOrderIdRequest, saleOrderNoRequest, StoreConsumptionDetails, StoreConsumptionItemsDto, StoreConsumptionReportResponse, StoreConsumptionResponse, StoreConsumptionSosDto, StoreIssueItems, StoreIssues, UpdatePlaceListStatus } from '@gtpl/shared-models/procurement-management';
import { Injectable } from '@nestjs/common';
import { LogActions } from 'apps/services/logger/logger-functions';
import { StoreConsumptionAdapter } from './adapter/store-consumption.adapter';
import { StoreConsumptionData } from './dto/store-consumption.dto';
import { StoreConsumption } from './entity/store-consumption.entity';
import { StoreConsumptionRepository } from './repository/store-consumption.repository';
import { SaleOrderService, saleOrder } from '@gtpl/shared-services/sale-management';
import { EmployeeService, ItemCategoryService, ItemsService, RackPositionService } from '@gtpl/shared-services/masters';
import { ItemCategoryReq, ItemCategoryResponse, ItemDetailsResponse, ItemRequest, ItemsDropDownDto, ItemsDropDownResponseModel, ItemCategoryDropDownDto, CommonResponse, LocationRequestDto, ReserveRackPositionsRequest, OccupancyEnum } from '@gtpl/shared-models/masters';
import { ProductBarcodeRequest, SaleOrderDetailViewInfoResponseModel } from '@gtpl/shared-models/sale-management';
import { catchError } from 'rxjs/operators';
import { Cron } from '@nestjs/schedule';
import { getConnection, getManager, Repository,In, CommandOptions } from 'typeorm';
import {  WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { Stock } from '../stock/stock.entity';
import { StoreConsumptionItems } from './entity/store-consumption-items.entity';
import { InjectRepository } from '@nestjs/typeorm';
import { ConsumedItemsForSoReq } from './dto/get-consumed-items.dto';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import appSettings from 'apps/services/config';
import { GetStoreConsumptionRequest } from './dto/get-store-consumption.request';
import { UnitIdRequest } from './dto/unit-id.request';
import { StockItemRequest } from '../stock/dto/stock-item.request';
import { ConsumtionReportRequest } from './dto/get-consumtion-report.request';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { whatsApp } from '../../../../whatsapp'
import { time } from 'console';
import { ItemCodeRequest } from '../stock/dto/item-code.request.dto';
import { StoreIssuesRequest } from './dto/store-issues-dto';
import { MaterialPreperationRepository } from '../stock/repository/material-preperation-repository';
import { StockRepository } from '../grn/repository/stock-repository';
import { PlaceListDto } from './dto/place-list.dto';
import { PlaceListItems } from './entity/place_list_items.entity';
import { PlaceListItemsRepository } from './entity/place-list-items.repository';
import { BroadCastMessageRequest } from "@gtpl/shared-models/whatsapp-broad-cast";
import { IndentFormDto } from '../indent/dto/indent-form.dto';
import { IndentFormAdapter } from '../indent/indent-form.adapter';
import { IndentForm } from './entity/packing-indent.entity';
import { IndentFormRepository } from './repository/indent-form.repository';
import { EtdWiseDto } from './dto/etd-wise.dto';
import { EtdWiseAdapter } from './adapter/etd-wise.adapter';
import { EtdWiseDataRepository } from './repository/etd-wise-grid.repository';
import { EtdWise } from './entity/etd-wise-grid.entity';
import { IndentRequest } from '../indent/dto/indent-data.request';
import { PackingIndentService } from '@gtpl/shared-services/procurement';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class StoreConsumptionService {

    constructor(
      private logService:LogsService,

        private storeConsumptionRepo: StoreConsumptionRepository,
        @InjectRepository(StoreConsumptionItems)
        private storeConsumptionItemsRepository: Repository<StoreConsumptionItems>,
        private storeConAdapter: StoreConsumptionAdapter,
        private soService: SaleOrderService,
        private employeeService: EmployeeService,
        private CategoryService: ItemCategoryService,
        private wpService: WhatsAppNotificationService,
        private itemService: ItemsService,
        private rackPosition: RackPositionService,
        @InjectRepository(PlaceListItems)
        private placeListRepo: Repository<PlaceListItems>,
        private placeListItemsRepository : PlaceListItemsRepository,
        private materialPreperationRepo : MaterialPreperationRepository,
        private wtsAppBroadCatService : WhatsappBroadCastService,
        private indentFormAdapter :IndentFormAdapter,
        private indentFormRepo : IndentFormRepository,
        private etdwiseAdapter : EtdWiseAdapter,
        private etdwiseRepo:EtdWiseDataRepository,

    ) { }

    /**
     * to Create or Update Store Consumption Data
     * @param storeConData 
     * @returns 
     */
    @LogActions({ isAsync: true })
    async createStoreConsumedStock(storeConData: StoreConsumptionData, isUpdate?: boolean): Promise<StoreConsumptionResponse> {
        const manager = new GenericTransactionManager();
        try {
            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();
            let fromDate = 0;
            let toDate = 0;
            const totalStoreConsumptions = await this.storeConsumptionRepo.count();
            if (!isUpdate) {
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                } else {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                }
            }
            const currentFinancialYear = "STRCON/" + (fromDate) + "-" + (toDate) + "/" + (totalStoreConsumptions + 1);
            // convert dto to entity
            const storeConsumptionEntity: StoreConsumption = await this.storeConAdapter.convertDtoToEntity(storeConData, currentFinancialYear);
            // save converted Entity
            await manager.startTransaction();
            const storeConRes = await manager.getCustomRepository(StoreConsumptionRepository).save(storeConsumptionEntity);
            
            const consItems: StoreConsumptionItemsDto[] = [];
            if (storeConRes) {
                let flag = true;
                for (const items of storeConData.storeConsumptionItems) {
                    if (items.stockType == 'Dummy'|| storeConData.soType == 'Dummy') {
                        let updateStock
                        if (items.isPreperationRequired == 'YES') {
                            updateStock = await manager.getRepository(Stock).update(
                                {
                                    saleOrderId: 0, itemId: items.itemId, unitId: storeConRes.unitId
                                }, {
                                preparedQuantity: () => `prepared_quantity-${items.quantity}`
                            }
                            );

                        } else {
                            updateStock = await manager.getRepository(Stock).update(
                                {
                                    saleOrderId: 0, itemId: items.itemId, unitId: storeConRes.unitId
                                }, {
                                physicalQuantity: () => `physical_quantity-${items.quantity}`
                            }
                            );
                        }
                        if (!updateStock.affected) {
                            flag = false;
                            break;
                        }
                    } else {
                        let updateStock
                        if (items.isPreperationRequired == 'YES') {
                            updateStock = await manager.getRepository(Stock).update(
                                {
                                    saleOrderId: storeConData.saleOrderId, itemId: items.itemId, unitId: storeConRes.unitId
                                }, {
                                preparedQuantity: () => `prepared_quantity-${items.quantity}`
                            }
                            );
                        } else {
                            updateStock = await manager.getRepository(Stock).update(
                                {
                                    saleOrderId: storeConData.saleOrderId, itemId: items.itemId, unitId: storeConRes.unitId
                                }, {
                                physicalQuantity: () => `physical_quantity-${items.quantity}`
                            }
                            );
                        }
                        if (!updateStock.affected) {
                            flag = false;
                            break;
                        }

                    }


                }
                for (const items of storeConRes.storeConsumptionItems) {

                    const itemsDto = new StoreConsumptionItemsDto(items.storeConsumptionItemsId, storeConRes.storeConsumptionId, items.itemCategoryId, items.itemId, items.availableStock, items.quantity, items.status, items.isActive, items.createdAt, items.createdUser, items.updatedAt, items.updatedUser, items.versionFlag)
                    consItems.push(itemsDto);
                }
                // get sale order details for sale order id
                const soReq: saleOrder = {
                    saleOrderId: storeConRes.saleOrderId
                }

                const saleOrderDetails = await this.soService.getSaleOrderInformationById(soReq);
                const salePersonDetails = await this.employeeService.getActiveEmployeesById({ employeeId: storeConRes.salePerson });
                const storeConsumptionDto = new StoreConsumptionDetails(storeConRes.consumedDate, storeConRes.indentDate, storeConRes.saleOrderId, storeConRes.storeConsumptionCode, storeConRes.indentNo, storeConRes.salePerson, storeConRes.status, storeConRes.createdUser, storeConRes.unitId, consItems, "", storeConRes.storeConsumptionId, (saleOrderDetails) ? saleOrderDetails.data : null, (salePersonDetails) ? salePersonDetails.data : null, storeConRes.updatedUser);
                if (flag) {
                    manager.completeTransaction();
                    return new StoreConsumptionResponse(true, 1111, 'Created Successfully', storeConsumptionDto)
                } else {
                    await manager.releaseTransaction();
                    throw new ErrorResponse(99998, 'Failed To Save');
                }
            } else {
                await manager.releaseTransaction();
                throw new ErrorResponse(99998, 'Failed To Save');
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }
    }


    /**
     * 
     * @returns all store consumption details
     */
    // @LogActions({isAsync: true})
    async getAllStoreConsumptionsDataOld(): Promise<getAllStoreConsumptionsResponse> {
        try {
            const response: StoreConsumption[] = await this.storeConsumptionRepo.find({ relations: ['storeConsumptionItems'] });
            if (response) {
                const storeConsumptionData: StoreConsumptionDetails[] = [];
                for (const storeConsumption of response) {
                    console.log(storeConsumption.saleOrderId);
                    const consItems: StoreConsumptionItemsDto[] = [];
                    for (const items of storeConsumption.storeConsumptionItems) {
                        const itemsDto = new StoreConsumptionItemsDto(items.storeConsumptionItemsId, storeConsumption.storeConsumptionId, items.itemCategoryId, items.itemId, items.availableStock, items.quantity, items.status, items.isActive, items.createdAt, items.createdUser, items.updatedAt, items.updatedUser, items.versionFlag)
                        consItems.push(itemsDto);
                    }
                    // get sale order details for sale order id
                    const soReq: saleOrder = {
                        saleOrderId: storeConsumption.saleOrderId
                    }
                    const saleOrderDetails = await this.soService.getSaleOrderInformationById(soReq);
                    console.log(saleOrderDetails);
                    const salePersonDetails = await this.employeeService.getActiveEmployeesById({ employeeId: storeConsumption.salePerson });
                    console.log(salePersonDetails);
                    const storeConsumptionDto = new StoreConsumptionDetails(storeConsumption.consumedDate, storeConsumption.indentDate, storeConsumption.saleOrderId, storeConsumption.storeConsumptionCode, storeConsumption.indentNo, storeConsumption.salePerson, storeConsumption.status, storeConsumption.createdUser, storeConsumption.unitId, consItems, "", storeConsumption.storeConsumptionId, (saleOrderDetails) ? saleOrderDetails.data : null, (salePersonDetails) ? salePersonDetails.data : null, storeConsumption.updatedUser);
                    storeConsumptionData.push(storeConsumptionDto);
                    console.log(storeConsumptionData);
                }
                return new getAllStoreConsumptionsResponse(true, 1111, 'Data Retrieved Successfully', storeConsumptionData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
    async getAllStoreConsumptions(req: UnitIdRequest): Promise<getAllStoreConsumptionsResponse> {
        try {
            const manager = getManager();
            let storeConsumptionQuery = `SELECT pli.place_list_items_id AS placeListItemId,sc.stock_type AS stockType, sc.item_id AS itemId,sc.issued_quantity AS issuedQuantity,sc.sale_order_item_id AS saleOrderItemId, sc.store_consumption_id AS storeConsumptionId,sc.consumed_date AS consumedDate,sc.indent_date AS indentDate,sc.sale_order_id AS saleOrderId,sc.store_consumption_code AS storeConsumptionCode,sc.indent_no AS indentNo,sc.status AS status,uc.unit_name AS unitId, CONCAT(so.sale_order_no," - ", inv.po_number) AS saleOrder,e.end_customer_name AS endCustomerName,sot.container_status AS containerStatus,sc.sale_order_id as saleOrderId , sc.unit_id as plantId , sc.stock_type as stockTypeStatus,sc.issued_quantity as issuedCases,sc.issued_quantity as quantity, i.item_name as itemName ,inv.po_number as saleOrderNo ,sc.barcode as barCode,sk.variant_code as soItem, CONCAT(inv.po_number,'-',b.brand_name,'/',sk.variant_code,'/',p.packing_method_name) AS soleOrderItem FROM ` + appSettings.procure_db + `.store_consumption sc LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=sc.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.sale_order_track sot ON sot.sale_order_id=sc.sale_order_id LEFT JOIN ` + appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id=sc.sale_order_id
            left join ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = sc.unit_id LEFT JOIN ` +
             appSettings.procure_db + `.place_list_items pli on pli.store_consumption_id = sc.store_consumption_id and pli.place_list_items_id = (select Max(pli.place_list_items_id) from `+appSettings.procure_db+`.place_list_items pli where pli.store_consumption_id = sc.store_consumption_id)
            LEFT JOIN ` + appSettings.masters_db + `.items i ON  i.item_id=sc.item_id 
            LEFT JOIN ` + appSettings.sales_db +  `.sale_order_items soi ON soi.sale_order_item_id = sc.sale_order_item_id 
            LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id = soi.varient_id 
            LEFT JOIN ` + appSettings.masters_db + `.packing_methods p ON p.packing_method_id=soi.pack_style_id 
            LEFT JOIN ` + appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id 
            where so.status!='${SoStatusEnum.CANCELLED}'`
            if ((([
                EmployeeRolesEnum.ADMIN
            ].indexOf(req.role)) === -1)) {
                storeConsumptionQuery + ` and sc.unit_id= ${req.unitId}`;
            }
            if (req.unitId && req.unitId != 5) {
                storeConsumptionQuery += `and sc.unit_id=` + req.unitId
            }
            storeConsumptionQuery = storeConsumptionQuery + ` ORDER BY sc.consumed_date DESC `
            const storeConsumptionData = await manager.query(storeConsumptionQuery);
            console.log('********',storeConsumptionData)
            if (storeConsumptionData.length > 0) {
                return new getAllStoreConsumptionsResponse(true, 1111, 'Data Retrieved Successfully', storeConsumptionData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            console.log(error)
            return error;
        }
    }
    async getStoreConsumptionItemsById(getStoreConsumptionRequest: GetStoreConsumptionRequest): Promise<GetAllConsumptionItemsResponseModel> {
        try {
            const manager = getManager();
            const query = `SELECT si.store_consumption_item_id AS storeConsumptionItemsId, si.store_consumption_id AS storeConsumptionId,i.item_name as itemName,si.quantity, si.item_id as itemId FROM ` + appSettings.procure_db + `.store_consumption_items si LEFT JOIN ` + appSettings.masters_db + `.items i ON  i.item_id=si.item_id
            WHERE si.store_consumption_id = `+ getStoreConsumptionRequest.storeConsumptionId;
            const ItemsData = await manager.query(query);
            if (ItemsData) {
                return new GetAllConsumptionItemsResponseModel(true, 1111, 'Data Retrieved Successfully', ItemsData)
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (err) {
            console.log(err);
            throw err;
        }
    }



    /**
     * 
     * @param id 
     * @returns 
     */
    @LogActions({ isAsync: true })
    async getStoreConsumptionDataForId(id: number): Promise<GetStoreConsumptionResponse> {
        console.log(id);
        try {
            const storeConsumptionId = id;
            const response = await this.storeConsumptionRepo.findOne({
                relations: ['storeConsumptionItems'],
                where: { storeConsumptionId: storeConsumptionId }
            });
            console.log('item Details By Id' + response);
            if (response) {
                // get sale order details for sale order id
                const soReq: saleOrder = {
                    saleOrderId: response.saleOrderId
                }

                const saleOrderDetails = await this.soService.getSaleOrderDetailsForId(soReq);
                if (!saleOrderDetails) {
                    throw new ErrorResponse(1111, 'Failed to Get Sale Order');
                }

                const itemsArray: GetStoreConsumptionItemsDto[] = []
                for (const consumptionItems of response.storeConsumptionItems) {

                    // get item category details for item category id
                    const itemCategoryReq = new ItemCategoryReq(consumptionItems.itemCategoryId);
                    const itemCategoryDetails = this.CategoryService.getItemCategoryById(itemCategoryReq);
                    if (!itemCategoryDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item Category');
                    }
                    // // get item details for item id 
                    const itemReq = new ItemRequest(consumptionItems.itemId);
                    const itemDetails = this.itemService.getItemById(itemReq);
                    if (!itemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item');
                    }

                    await Promise.all([itemCategoryDetails, itemDetails]).then(res => {
                        const item = new GetStoreConsumptionItemsDto(consumptionItems.storeConsumptionItemsId, response.storeConsumptionId, (res[0]) ? res[0] : null, (res[1]) ? res[1] : null, consumptionItems.quantity, consumptionItems.status, consumptionItems.isActive, consumptionItems.createdAt, consumptionItems.createdUser, consumptionItems.updatedAt, consumptionItems.updatedUser, consumptionItems.versionFlag);
                        itemsArray.push(item);
                    })
                }
                const consumptionData = new GetStoreConsumptionDetails(response.consumedDate, response.indentDate, response.saleOrderId, (saleOrderDetails) ? saleOrderDetails : null, response.storeConsumptionCode, response.indentNo, response.status, response.createdUser, itemsArray, response.storeConsumptionId, response.updatedUser);
                console.log(consumptionData);

                return new GetStoreConsumptionResponse(true, 1111, 'Data Retrieved Successfully', consumptionData)
            } else {
                throw new ErrorResponse(99998, 'No Data Found');
            }
        }
        catch (error) {
            return error;
        }
    }

    @LogActions({ isAsync: true })
    async getConsumedItemsForSo(req: ConsumedItemsForSoReq) {
        try {
            let consumedItems;
            if (req.saleOrderId && req.storeConsumptionId) {
                consumedItems = await this.getConsumedItems(req);
            } else {
                consumedItems = await this.getSoConsumedItems(req);
            }
            if (consumedItems && consumedItems.length > 0) {
                const itemDTO: ItemsDropDownDto[] = [];
                for (const item of consumedItems) {
                    // get item details for item id 
                    const itemReq = new ItemRequest(item.itemId);
                    const itemDetails = await this.itemService.getItemById(itemReq);
                    if (!itemDetails) {
                        throw new ErrorResponse(1111, 'Failed to Get Item');
                    }
                    itemDTO.push(itemDetails);
                }
                const response = new ItemsDropDownResponseModel(true, 11108, "Item retrieved successfully", itemDTO);
                return response;
            } else {
                throw new ErrorResponse(1111, 'Issued Items are not found');
            }
        } catch (error) {
            return error;
        }

    }

    async getConsumedItems(req: ConsumedItemsForSoReq) {
        try {
            console.log("with out So");
            const response = await this.storeConsumptionRepo.createQueryBuilder('store_consumption')
                .select('storeConsumptionItems.item_id as itemId')
                .leftJoin('store_consumption.storeConsumptionItems', 'storeConsumptionItems')
                .where(`store_consumption.store_consumption_id IN(` + req.storeConsumptionId + `)`)
                .groupBy('storeConsumptionItems.item_id')
                .getRawMany();
            return response;
        } catch (error) {
            return error;
        }
    }

    async getSoConsumedItems(req: ConsumedItemsForSoReq) {
        try {
            console.log("with So");
            const response = await this.storeConsumptionRepo.createQueryBuilder('store_consumption')
                .select('storeConsumptionItems.item_id as itemId')
                .leftJoin('store_consumption.storeConsumptionItems', 'storeConsumptionItems')
                .where(`store_consumption.sale_order_id = ` + req.saleOrderId)
                .groupBy('storeConsumptionItems.item_id')
                .getRawMany();
            return response;
        } catch (error) {
            return error;
        }
    }


    async getConsumedQty(req: ConsumedQtyRequest) {
        try {
            // if (req.saleOrderId && req.storeConsumptionId && req.itemId) {
            //     response = await this.storeConsumptionItemsRepository.createQueryBuilder('store_consumption_items')
            //         .select('sum(quantity)-sum(storeReturn.returned_quantity) as qty')
            //         .leftJoin('store_consumption_items.storeConsumptionInfo', 'storeConsumptionInfo')
            //         .leftJoin('store_return', 'storeReturn', 'storeReturn.item_id=storeConsumptionInfo.item_id')
            //         .where(`storeConsumptionInfo.store_consumption_id IN ( ` + req.storeConsumptionId + `) and storeConsumptionInfo.item_id =` + req.itemId + ` and storeConsumptionInfo.unit_id=` + req.unitId)
            //         .groupBy('item_id')
            //         .getRawOne();
            // } else {
            const consumedQty = await this.storeConsumptionItemsRepository.createQueryBuilder('store_consumption_items')
                .select('sum(quantity) as qty')
                .leftJoin('store_consumption_items.storeConsumptionInfo', 'storeConsumptionInfo')
                .where(`storeConsumptionInfo.sale_order_id = ` + req.saleOrderId + ` and store_consumption_items.item_id =` + req.itemId + ` and storeConsumptionInfo.unit_id=` + req.unitId)
                .groupBy('store_consumption_items.item_id')
                .getRawOne();

            console.log(consumedQty);
            console.log('consumedQty');

            const managerQuery = getManager();
            const existed = `SELECT sum(s.return_quantity) as returnQty from ` + appSettings.procure_db + `.store_return s where sale_order_id =${req.saleOrderId} and item_id='${req.itemId}' and s.unit_id=${req.unitId} group by item_id`;

            let returnedQty = await managerQuery.query(existed);
            console.log(returnedQty);
            console.log('returnedQty');
            // const returnedQty = await this.storeConsumptionItemsRepository.createQueryBuilder('store_return')
            //     .select('sum(store_return.return_quantity) as returnQty')
            //     .where(`store_return.sale_order_id = ` + req.saleOrderId + ` and store_return.item_id =` + req.itemId + ` and store_return.unit_id=` + req.unitId)
            //     .groupBy('store_return.item_id')
            //     .getRawOne();
            // console.log(returnedQty);
            let qty = 0;
            if (returnedQty?.length) {
                returnedQty = returnedQty.find((val) => val.returnQty)
                qty = Number(consumedQty.qty) - Number(returnedQty.returnQty);
            } else {
                qty = Number(consumedQty.qty)
            }
            console.log(qty);
            console.log('qty');
            // }
            if (qty) {
                return qty;
            } else {
                return 0;
            }
        } catch (error) {
            return error;
        }
    }

    @LogActions({ isAsync: true })
    async getConsumedNumbers(storeConData: ConsumedItemsForSoReq): Promise<IssuesDropDownResponse> {
        try {
            console.log(storeConData);
            const strCon: IssueDropDownDto[] = [];
            const issueEntities: IssueDropDownDto[] = await this.storeConsumptionRepo.find({
                where: { saleOrderId: storeConData.saleOrderId },
                select: ['storeConsumptionId', 'storeConsumptionCode'],
                order: { 'createdAt': 'DESC' }
            });
            console.log(issueEntities);
            if (issueEntities && issueEntities.length > 0) {
                // issueEntities.forEach(issues => {
                //     strCon.push(new IssueDropDownDto(issues.storeConsumptionId, issues.storeConsumptionCode));
                // });
                const response = new IssuesDropDownResponse(true, 11108, "Store Consumption Numbers retrieved successfully", issueEntities);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }
    async getStoreConsumptionSOs(req: UnitIdRequest): Promise<GetStoreConsumptionSosResponseModel> {
        try {
            const manager = getManager();
            let saleOrdersQuery = `SELECT con.sale_order_id as saleOrderId, so.sale_order_no as saleOrderNo, inv.po_number as poNumber  from ` + appSettings.procure_db + `.store_consumption as con 
            left join `+ appSettings.sales_db + `.sale_order so on con.sale_order_id = so.sale_order_id 
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=so.sale_order_id 
            `;

            if ((([
                EmployeeRolesEnum.ADMIN
            ].indexOf(req.role)) === -1)) {
                saleOrdersQuery += ` where con.unit_id= ${req.unitId}`;
            }

            saleOrdersQuery += ` group by con.sale_order_id`;
            const storeReturnDTO: StoreConsumptionSosDto[] = await manager.query(saleOrdersQuery);

            if (storeReturnDTO) {
                return new GetStoreConsumptionSosResponseModel(true, 1111, 'Data Retrieved Successfully', storeReturnDTO)
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getConsumedStockQty(req: StockItemRequest): Promise<CommonResponse> {
        try {
            const itemQty = await this.storeConsumptionRepo.createQueryBuilder('store_consumption')
                .select('sum(quantity)-COALESCE(sum(return_quantity),0) as consumedQty')
                .leftJoin('store_consumption.storeConsumptionItems', 'storeConsumptionItems')
                .leftJoin('store_return', 'store_return', 'store_consumption.sale_order_id = store_return.sale_order_id and storeConsumptionItems.item_id = store_return.item_id')
                .where(`store_consumption.sale_order_id = ` + req.saleOrderId)
                .andWhere(`storeConsumptionItems.item_id = ` + req.itemId)
                .andWhere(`store_consumption.unit_id = ` + req.unitId)
                .groupBy('storeConsumptionItems.item_id')
                .getRawOne();

            if (itemQty) {
                return new CommonResponse(true, 1111, 'QTY Found', itemQty)
            } else {
                return new CommonResponse(false, 1111, 'consumed Quantity Found')
            }
        } catch (error) {
            console.log(error);
            return error
        }
    }

    async getAvailableConsumedStockForSO(req?: ConsumtionReportRequest): Promise<StoreConsumptionReportResponse> {
        console.log(req, '--req--')
        try {
            const manager = getManager();
            let query = `SELECT sc.store_consumption_code AS consumptionCode, sc.consumed_date AS consumedDate,sc.unit_id,uc.unit_name AS unitName, si.po_number AS saleOrder, sc.issued_quantity AS issuedQty, i.item_name AS itemName, sc.sale_order_id AS poNumber,sc.item_id AS itemId,sc.created_at AS createdDate FROM ` + appSettings.procure_db + `.store_consumption sc
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = sc.sale_order_id
            LEFT JOIN ` + appSettings.procure_db + `.store_consumption_items sci ON sci.store_consumption_id = sc.store_consumption_id 
            LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = sc.item_id 
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = sc.unit_id
            WHERE sc.store_consumption_id > 0` ;
            if (req.unitId && req.unitId != 5) {
                query = query + ' and sc.unit_id = ' + req.unitId;
            }
            if (req.consumedFromDate != undefined) {
                query = query + ' and Date(sc.consumed_date) between  "' + req.consumedFromDate + '" and "' + req.consumedToDate + '"';
            }
            if (req.createdDate != undefined) {
                query = query + ' and DATE(sc.created_at) >=  "' + req.consumedFromDate + '" and DATE(sc.created_at) <="' + req.consumedToDate + '"';
            }
            if (req.saleOrderId) {
                query = query + ' and sc.sale_order_id = ' + req.saleOrderId;
            }
            if (req.itemId) {
                query = query + ' and sc.item_id = ' + req.itemId;
            }
            const storeConsumptionData = await manager.query(query);
            if (storeConsumptionData.length > 0) {
                const response = new StoreConsumptionReportResponse(true, 11208, 'Consumption Data  Retrived successfully', storeConsumptionData);
                return response;
            }
            else {
                throw new ErrorResponse(99998, 'No Data Found');
            }
        }
        catch (err) {
            throw err
        }
    }
    async getSoDropForScReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT sc.sale_order_id AS saleOrderId , si.po_number AS poNumber , sc.unit_id FROM ` + appSettings.procure_db + `.store_consumption sc
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = sc.sale_order_id
        WHERE sc.sale_order_id > 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and sc.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY sc.sale_order_id  ORDER BY poNumber `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1421, 'No data')
        }
    }
    async getItemDropForScReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = ` SELECT sc.item_id AS itemId , i.item_name AS itemName , sc.unit_id FROM ` + appSettings.procure_db + `.store_consumption sc
        LEFT JOIN ` + appSettings.procure_db + `.store_consumption_items sci ON sci.store_consumption_id = sc.store_consumption_id
        LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = sc.item_id 
        WHERE i.item_id > 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and sc.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY i.item_id  ORDER BY itemName `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1421, 'No data')
        }
    }


    async getAllCancelledSosStoreConsumptions(req: UnitIdRequest): Promise<getAllStoreConsumptionsResponse> {
        try {
            const manager = getManager();
            let storeConsumptionQuery = `SELECT sc.store_consumption_id AS storeConsumptionId,sc.consumed_date AS consumedDate,sc.indent_date AS indentDate,sc.sale_order_id AS saleOrderId,sc.store_consumption_code AS storeConsumptionCode,sc.indent_no AS indentNo,sc.status AS status,sc.unit_id AS unitId, CONCAT(so.sale_order_no," - ", inv.po_number) AS saleOrder,e.end_customer_name AS endCustomerName,sc.issued_quantity as quantity, sc.barcode as barCode,i.item_name as itemName FROM ` + appSettings.procure_db + `.store_consumption sc LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=sc.sale_order_id LEFT JOIN ` + appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id=sc.sale_order_id LEFT JOIN `+ appSettings.masters_db +`.items i ON i.item_id = sc.item_id where so.status='${SoStatusEnum.CANCELLED}'`;

            if ((([
                EmployeeRolesEnum.ADMIN
            ].indexOf(req.role)) === -1)) {
                storeConsumptionQuery += ` and sc.unit_id= ${req.unitId}`;
            }

            const storeConsumptionData = await manager.query(storeConsumptionQuery);
            if (storeConsumptionData.length > 0) {
                return new getAllStoreConsumptionsResponse(true, 1111, 'Data Retrieved Successfully', storeConsumptionData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error;
        }
    }

    async getAllRevisedSosStoreConsumptions(req: UnitIdRequest): Promise<getAllStoreConsumptionsResponse> {
        try {
            const manager = getManager();
            let storeConsumptionQuery = `SELECT sc.store_consumption_id AS storeConsumptionId,sc.consumed_date AS consumedDate,sc.indent_date AS indentDate,sc.sale_order_id AS saleOrderId,sc.store_consumption_code AS storeConsumptionCode,sc.indent_no AS indentNo,sc.status AS status,sc.unit_id AS unitId, CONCAT(so.sale_order_no," - ", inv.po_number) AS saleOrder,e.end_customer_name AS endCustomerName 
            FROM ` + appSettings.procure_db + `.store_consumption sc 
            LEFT JOIN ` + appSettings.procure_db + `.store_consumption_items si ON si.store_consumption_id=sc.store_consumption_id 
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=sc.sale_order_id 
            LEFT JOIN ` + appSettings.masters_db + `.end_customers e ON e.end_customer_id=inv.end_customer_id 
            LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id=sc.sale_order_id 
            LEFT JOIN ` + appSettings.sales_db + `.bom_details bom ON bom.sale_order_id=sc.sale_order_id and bom.item_id = si.item_id 
            where bom.is_qty_revised='${GlobalStatus.YES}' and bom.is_required='${GlobalStatus.NO}'`;
            if ((([
                EmployeeRolesEnum.ADMIN
            ].indexOf(req.role)) === -1)) {
                storeConsumptionQuery += ` and sc.unit_id= ${req.unitId}`;
            }
            const storeConsumptionData = await manager.query(storeConsumptionQuery);
            if (storeConsumptionData.length > 0) {
                return new getAllStoreConsumptionsResponse(true, 1111, 'Data Retrieved Successfully', storeConsumptionData);
            } else {
                return new getAllStoreConsumptionsResponse(false, 1111, 'No data');
            }
        } catch (error) {
            return error;
        }
    }
    // @Cron('0 19 * * *')
    async getStoreConsumptionUsage() {
        try {
            const manager = getManager();
            let query = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_procurement.store_consumption sc
            LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = sc.unit_id WHERE DATE(sc.created_at)=DATE(NOW())
            GROUP BY sc.unit_id ORDER BY sc.unit_id `
            const scData = await manager.query(query);
            const messageType = new Date();
            const month = messageType.getMonth() + 1
            const scDate = messageType.getFullYear() + '-' + month + '-' + messageType.getDate();
            const time = messageType.toLocaleTimeString()
            let messageStatus
            if (scData.length > 0) {
                let storeconsumptionData = scDate+" : "+time;
                for (const sd of scData) {
                    storeconsumptionData += sd.unit_name + "  *" + sd.cnt + "*\n";
                }
                //Whatsapp braodcast API calling
                const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(4,storeconsumptionData,[whatsApp.UsageReport]));

                // const message = await new MessageRequest(whatsApp.UsageReport, `Store Consumption :${scDate} : ${time}`, storeconsumptionData, "Schemax")
                // console.log(message);
                // var messageStatus = await this.wpService.sendPersonalMessage(message);
            } else {
                const Nodatamsg = scDate+" : "+time+ "*\n"+'No data'
                //Whatsapp braodcast API calling
                const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(4,Nodatamsg,[whatsApp.UsageReport]));
                // const message = await new MessageRequest(whatsApp.UsageReport, `Store Consumption :${scDate} : ${time}`, "No data", "Schemax")
                // console.log(message);
                // var messageStatus = await this.wpService.sendPersonalMessage(message);
            }
            console.log(messageStatus);
            return new CommonResponse(true, 11108, "transfer data retrived", scData)
        } catch (error) {
            return new CommonResponse(false, 11108, "No data found")
        }
    }
    async getIssuedQty(req: ItemCodeRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            // let itemQuery = "Select item_id AS itemId, item_code AS itemCode, item_name AS itemName from "+appSettings.masters_db+ ".items where item_code = '" + req.itemCode+"'";
            // let itemResult = await manager.query(itemQuery);
            // if(itemResult[0].itemId > 0){
                let query = `SELECT IF(sc.issued_quantity < pm.max_pallet_capacity, sc.issued_quantity,pm.max_pallet_capacity) AS palletCapacity,SUM(sc.issued_quantity) AS issuedQuantity,SUM(sc.stock_in_quantity) AS stockInQuantity,Group_Concat(sc.store_consumption_id) AS storeConsumptionIds,sc.store_consumption_id AS storeConsumptionId,soi.sale_order_id AS saleOrderId,sc.sale_order_item_id AS saleOrderItemId, soi.po_number AS saleOrderNumber,CONCAT(pm.packing_method_name,'/',sk.variant_code) AS productCode , si.varient_id AS variantId, sk.variant_code AS varient, si.pack_style_id AS packStyleId, soi.end_customer_id AS endCustomerId,sc.stock_type AS stockType, sc.transaction_type AS transactionType from `+ appSettings.procure_db + `.store_consumption sc left join `+appSettings.sales_db+`.so_invoice_details soi on soi.sale_order_id = sc.sale_order_id left join `+appSettings.sales_db+`.sale_order_items si on si.sale_order_item_id = sc.sale_order_item_id left join `+appSettings.masters_db+`.sku_codes sk on sk.sku_code_id = si.varient_id left join `+appSettings.masters_db+`.packing_methods pm on pm.packing_method_id = si.pack_style_id where sc.unit_id = ` + req.unitId + ` and sc.barcode = '`+req.itemCode+`' and sc.issued_quantity > 0 group by sc.sale_order_id,sc.sale_order_id,sc.transaction_type,sc.stock_type Having (SUM(sc.issued_quantity) - SUM(sc.stock_in_quantity)) <= SUM(sc.issued_quantity) order by soi.po_number ASC`;
                let queryResult = await manager.query(query);
                if (queryResult.length > 0) {
                    return new CommonResponse(true, 1001, "Issued quantity retreived successfully. ", queryResult);
                }
                else {
                    return new CommonResponse(false, 1010, "Issued quantity not found. ", queryResult);
                }
            // }
            // else{
            //     return new CommonResponse(false,1010,"No item found for barcode");
            // }
        }
        catch (error) {
            return new CommonResponse(false, 11108, "No data found")
        }
    }

    async createStoreIssues(req: StoreIssuesRequest, isUpdate: boolean = false): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            const preaparedData = await this.materialPreperationRepo.findOne({
                select:['preparedStockId'],
                order:{ preparedStockId: "DESC" }
            })
            let maxId
            if(preaparedData){
                maxId = Number(preaparedData.preparedStockId)+1;
            }else{
                maxId = 1
            }
            var refNo = maxId + "";
            while (refNo.length < 4) refNo = "0" + refNo;
            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();
            let fromDate = 0;
            let toDate = 0;
            const totalStoreConsumptions = await this.storeConsumptionRepo.count();
            if (!isUpdate) {
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                } else {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                }
            }
            const currentFinancialYear = "STRCON/" + (fromDate) + "-" + (toDate) + "/" + (totalStoreConsumptions + 1);
            let barcode
                let productName
            if(req.stockType == StockStatus.Anticipated ||req.stockType == StockStatus.SaleOrder || req.stockType == StockStatus.dummy || req.stockType == StockStatus.superDummy){
                const barcomboExist = await this.storeConsumptionRepo.findOne({ where: { saleOrderId: req.saleOrderId, saleOrderItemId: req.saleOrderItemId } })
                const productBarcodeData = await this.soService.getProductBarcode(new ProductBarcodeRequest(req.saleOrderId,req.saleOrderItemId,req.itemId));
                
                if(!(productBarcodeData.status)){
                    await manager.releaseTransaction()
                    return new CommonResponse(false, 11101, 'barcode not exist', undefined);
                }
                const soItemBarcode = productBarcodeData.data

                
                if (barcomboExist) {
                    barcode = barcomboExist.barcode
                } else {
                    barcode = soItemBarcode
                }
                if (barcomboExist) {
                    productName = barcomboExist.productName
                } else {
                    productName = req.poNumber + '/' + req.soItemName + '/' + req.itemName
                }
            }else{
                console.log('yeselseee')
                barcode = 'GI'
                productName = 'GI'
            }

            // convert dto to entity
            const storeConsumptionEntity: StoreConsumption = await this.storeConAdapter.convertStoreIssuesDtoToEntity(req, currentFinancialYear, barcode,productName);
            // save converted Entity
            await manager.startTransaction();

            const storeConRes = await manager.getCustomRepository(StoreConsumptionRepository).save(storeConsumptionEntity);
            let updateFlag = new Set<boolean>()
            if (storeConRes) {
                if (req.isPreparedMaterial == GlobalStatus.YES) {
                    const preparedMaterialInfo = await manager.getCustomRepository(MaterialPreperationRepository).find({ where: { barcode: req.barcode, status: In([MaterialPreperationStatus.PARTIALLY_CONSUMED, MaterialPreperationStatus.PREPARED]) } })
                    if (preparedMaterialInfo.length > 0) {
                        let storeIssueQty = req.issuedQuantity
                        let toBeupdateQty
                        for (const stockItem of preparedMaterialInfo) {
                            if ((stockItem.preparedQuantity - stockItem.consumedQuantity) < storeIssueQty) {
                                toBeupdateQty = stockItem.preparedQuantity - stockItem.consumedQuantity
                                storeIssueQty = storeIssueQty - (stockItem.preparedQuantity - stockItem.consumedQuantity);
                                const preperationStockUpdate = await manager.getCustomRepository(MaterialPreperationRepository).update({ preparedStockId: stockItem.preparedStockId }, { consumedQuantity: () => `consumed_quantity+${toBeupdateQty}`, storeIssueId: storeConRes.storeConsumptionId, status: MaterialPreperationStatus.CONSUMED })
                                if (preperationStockUpdate.affected) {
                                    updateFlag.add(true)
                                } else {
                                    updateFlag.add(false)
                                }
                            } else {
                                toBeupdateQty = storeIssueQty
                                const preperationStockUpdate = await manager.getCustomRepository(MaterialPreperationRepository).update({ preparedStockId: stockItem.preparedStockId }, { consumedQuantity: () => `consumed_quantity+${toBeupdateQty}`, storeIssueId: storeConRes.storeConsumptionId, status: MaterialPreperationStatus.PARTIALLY_CONSUMED })
                                if (preperationStockUpdate.affected) {
                                    updateFlag.add(true)
                                } else {
                                    updateFlag.add(false)
                                }
                                break
                            }
                        }
                // const updateisuuedquantiy = await this.packingindentService.updateIssuedQuantity(new indentrequest(req.indentNo,req.status:44));
                            
                        if (!updateFlag.has(false)) {

                            await manager.completeTransaction();
                            return new CommonResponse(true, 1111, 'Create successfully')
                        } else {
                            await manager.releaseTransaction();
                            return new CommonResponse(true, 1111, 'Somethingggg Went wrong')
                        }
                    } else {
                        await manager.releaseTransaction();
                        return new CommonResponse(false, 1111, 'no prepared stock found')
                    }


                } else {
                    let stockUpdate
                    if(req.stockType == 'SaleOrder' && req.issueType == 'INDENT'){
                        stockUpdate = await manager.getCustomRepository(StockRepository).update({ saleOrderId: req.saleOrderId, itemId: req.itemId, unitId: req.unitId }, { physicalQuantity: () => `physical_quantity-${req.issuedQuantity}` })
                    }else{
                        stockUpdate = await manager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: req.itemId, unitId: req.unitId }, { physicalQuantity: () => `physical_quantity-${req.issuedQuantity}` })
                    }
                    if (stockUpdate.affected) {
                        await manager.completeTransaction();
                        return new CommonResponse(true, 1111, 'Created Successfully')
                    } else {
                        await manager.releaseTransaction();
                        return new CommonResponse(false, 1111, 'something went wrong')
                    }
                }
            } else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 1111, 'not saved')
            }
        } catch (err) {
            await manager.releaseTransaction();
            return new CommonResponse(false, 1111, err)
        }
    }

    async getPlaceListData(dto: any): Promise<CommonResponse> {
        const manager = getManager();
        try{
            const itemQuery = `SELECT pm.max_pallet_capacity AS palletcapacity,pack_style_id AS packStyleId , varient_id as varientId FROM ` +appSettings.sales_db + `.sale_order_items si left join `+appSettings.masters_db+`.packing_methods pm on pm.packing_method_id = si.pack_style_id where sale_order_item_id =`+ dto.saleOrderItemId
            let data = await manager.query(itemQuery);
            console.log(dto);
            const req = new ReserveRackPositionsRequest(dto.plantId,dto.saleOrderId,dto.saleOrderItemId,dto.issuedQuantity,dto.stockType,data[0]?.varientId,data[0]?.packStyleId);
            console.log("****"+req);
            const reserveRackPosition = await this.rackPosition.reserveRacksForIssuedQty(req)
            console.log('reserveRack', reserveRackPosition)
            const rackQuery = ` SELECT rack_reserve_code AS rackReserveCode,rack_code AS rackCode, rack_position_id as rackPositionId ,plant_id as plantId,sale_order_id as  saleOrderId ,is_reserved as isReserved , occupancy as occupancy FROM ` + appSettings.masters_db + `.rack_position WHERE sale_order_id = `+dto.saleOrderId+` and sale_order_item_id = `+dto.saleOrderItemId+` and is_reserved = true  AND occupancy != 'Assigned' `
            let rackdata = await manager.query(rackQuery)
            console.log('final query',rackdata)
            
            let flag;
            for (const items of rackdata) {
                const dataToSave = new PlaceListDto()
                dataToSave.storeConsumptionId = dto.storeConsumptionId
                dataToSave.issuedQty = dto.issuedQuantity;
                dataToSave.palletCapacity = data[0].palletCapacity;
                dataToSave.palletCode = undefined;
                dataToSave.rackReserveCode = data[0].rackReserveCode;
                dataToSave.itemId = dto.itemId;
                dataToSave.rackPosition = items.rackCode;
                dataToSave.rackPositionId = items.rackPositionId;
                dataToSave.createdUser = dto.createdUser;
                dataToSave.updatedUser = dto.updatedUser;
                dataToSave.reportingQty = dto.issuedQuantity <= data[0].palletCapacity ?dto.issuedQuantity:data[0].palletCapacity;

                console.log(dataToSave);
                const saveData = await this.placeListItemsRepository.save(dataToSave)
                if(saveData.placeListItemsId > 0){
                    flag = true
                }
                else{
                    flag = false
                }
            }
            
            if (flag) {
                return new CommonResponse(true, 1111, 'Create successfully')
            }
            else{
                return new CommonResponse(false, 1011, 'Something went wrong. ')
            }
        }catch(err){
            console.log("err");
            console.log(err);
            return new CommonResponse(false, 1111, err)
        }
    }

    async updatePalletCodeInPlaceList(req: PlaceListPalletDto): Promise<CommonResponse> {
        const manager = getManager();
        try{
            let updatepalletCode = await manager.getCustomRepository(PlaceListItemsRepository).update({ storeConsumptionId: req.storeConsumptionId, rackPositionId:req.rackPosition }, { palletCode: req.palletCode});
            if(updatepalletCode.affected > 0){
                return new CommonResponse(true, 1111, 'Data Retrieved Successfully',updatepalletCode);
            }
            else{
                return new CommonResponse(false, 1001, 'Something Went Wrong. ',updatepalletCode);
            }
        }catch(err){
            console.log("err");
            console.log(err);
            return new CommonResponse(false, 1111, err)
        }
    }
    async placeListPrintData(getStoreConsumptionRequest: GetStoreConsumptionRequest): Promise<CommonResponse> {
        const manager = getManager()
        const query = `SELECT pl.store_consumption_id as storeConsumptionId , pl.rack_position as rackPosition ,pl.pallet_code as palletCode,pl.pallet_capacity as cartons,i.item_name as item FROM ` + appSettings.procure_db + `.place_list_items pl 
        LEFT JOIN ` +appSettings.masters_db +`.items i ON i.item_id = pl.item_id WHERE pl.store_consumption_id = ` + getStoreConsumptionRequest.storeConsumptionId;
        let data = await manager.query(query);
        if (data.length > 0) {
            return new CommonResponse(true, 1111, 'Retrived successfully', data)
        }else{
            return new CommonResponse(false, 1011, 'Something went wrong. ')
        }
    }

    async updatePlaceListStatus(req: UpdatePlaceListStatus) :Promise<CommonResponse>{
        try{
            let updateStatus = await this.placeListRepo.update({rackPositionId:req.rackPosition,storeConsumptionId:req.storeConsumptionId},{ occupancy: OccupancyEnum.ASSIGNED});
            if(updateStatus.affected > 0){
                return new CommonResponse(true,1001,"Updated Rack position successfully. ",);
            }
            else{
                return new CommonResponse(false,1010,"Something went wrong. ",);
            }
        }catch(err){
            console.log(err);
            return new CommonResponse(false, 1111, err)
        }
    }
    async updateReportedStock(req: UpdatePlaceListStatus) :Promise<CommonResponse>{
        try{
            let updateStock = await this.storeConsumptionRepo.update({storeConsumptionId:req.storeConsumptionId},{stockInQuantity: () => `stock_in_quantity+${req.reportedCases}`})
            if(updateStock.affected > 0){
                return new CommonResponse(true,1001,"Updated Reported Cases successfully. ",);
            }
            else{
                return new CommonResponse(false,1010,"Something went wrong. ",);
            }
        }catch(err){
            console.log(err);
            return new CommonResponse(false, 1111, err)
        }
    }



    async getSosForIndentForm():Promise<CommonResponse>{
        const manager = getManager()
        const query = `SELECT po_number as poNumber , sale_order_id as saleOrderId from ` + appSettings.sales_db +`.so_invoice_details`
        const data = await manager.query(query);
        if(data.length > 0 ){
            return new CommonResponse(true, 1111, 'Data Retrieved Successfully', data);
        } else {
            return new CommonResponse(false, 1111, 'No data');
        }
    }

    async getCountOfIndent():Promise<CommonResponse>{
        const manager = getManager()
        const countQuery = `SELECT COUNT(indent_form_id) as indCount FROM ` + appSettings.procure_db + `.indent_form `
        const data = await manager.query(countQuery);
        if(data.length > 0 ){
            return new CommonResponse(true, 1111, 'Data Retrieved Successfully', data);
        } else {
            return new CommonResponse(false, 1111, 'No data');
        }
    }

    async getEtdWiseData(req:saleOrderNoRequest):Promise<CommonResponse>{
        const manager = getManager()
        let query = `SELECT sid.po_number as saleOrder ,CONCAT(po_number,"-",b.brand_name,"/",variant_code,"/",packing_method_name) as soItem,sid.sale_order_id as saleOrderId, sid.act_edl_date as etd ,sid.sale_order_id as saleOrderId,sid.invoice_date as invoiceDate,sid.edl_date as edlDate,c.country_name as country FROM ` +appSettings.sales_db + `.so_invoice_details sid
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = sid.sale_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.sale_order_items soi on soi.sale_order_id=sid.sale_order_id
        LEFT JOIN ` + appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id 
        LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=soi.varient_id 
        LEFT JOIN ` + appSettings.masters_db + `.packing_methods p ON p.packing_method_id=soi.pack_style_id 
        left join ` + appSettings.masters_db + `.countries c on c.country_id = sid.country_id
        WHERE so.status IN ('OPEN' , 'INPROGRESS') and so.so_process_type="MTO" and sid.sale_order_id > 0 and sid.processing_unit = ${req.unitId} ` 
        if(req.saleOrderId){
            query = query + ' and sid.sale_order_id = ' + req.saleOrderId
        }
        query = query + ' group by soi.sale_order_id '
        const data = await manager.query(query)
        if(data.length > 0 ){
        const dataa = new CommonResponse(true, 1111, 'Data Retrieved Successfully', data);   
        // const newLogDto = new LogsDto(1,'view', 'EtdWise', 0, true, 'Data Retrieved Successfully','')
        //     let res = await this.logService.createLog(newLogDto);
        //     console.log(res);
        return dataa
        }else {
            return new CommonResponse(false, 1111, 'No data');
        }
    }

    async getPoNumberForEtdGrid():Promise<CommonResponse>{
        const manager = getManager()
        const query = `SELECT sid.po_number as saleOrder , sid.sale_order_id as saleOrderId FROM ` +appSettings.sales_db + `.so_invoice_details sid
        LEFT JOIN ` + appSettings.sales_db + `.sale_order so ON so.sale_order_id = sid.sale_order_id
         WHERE so.status IN ('OPEN' , 'INPROGRESS')  ` 
        const data = await manager.query(query)
        if(data.length > 0 ){
            return new CommonResponse(true, 1111, 'Data Retrieved Successfully', data);
        }else {
            return new CommonResponse(false, 1111, 'No data');
        }
    }

    async saveEtdWiseGridData(dto:EtdWiseDto[]):Promise<CommonResponse>{
        const manager = new GenericTransactionManager();
        await manager.startTransaction()
        
        try{
            const convertEtdWiseEntity:EtdWise[] = this.etdwiseAdapter.convertDtoToEntity(dto);
            console.log(convertEtdWiseEntity)
            const savedEtdWiseEntity: EtdWise[] = await manager.getRepository(EtdWise).save(convertEtdWiseEntity);
            console.log(savedEtdWiseEntity)
            const updateSoInvocie = await this.soService.updateEdlDateInInvoiceDetail(dto)
            console.log(updateSoInvocie)
            if (!updateSoInvocie.status){
                await manager.releaseTransaction()
                return updateSoInvocie
            } 
            if (savedEtdWiseEntity) {
                await manager.completeTransaction()
                const response = new CommonResponse(true, 11101,'Updated Successfully', savedEtdWiseEntity);
            //     const newLogDto = new LogsDto(1,'updated', 'EtdWise', 0, true, 'Updated Successfully','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
                return response;
            } else {
                throw new ErrorResponse(1011, 'Something went wrong');
            }
        }catch (error) {
            console.log(error)
            await manager.releaseTransaction()
            return error;
        }
    }

    // async updateEtdDate():Promise<CommonResponse>{
    //     const manager = new GenericTransactionManager();
    //     try{
    //         await manager.startTransaction();
    //         let soInvoiceDetails
    //         soInvoiceDetails = await manager.getCustomRepository(SoInvoiceRepository)

    //     }catch (error) {
    //         manager.releaseTransaction();
    //         return error;
    //     }
    // }
}



